module.exports = new __parcel__URL__("Druideskill_32.02a5e866.png").toString();